import { Box, Button, SxProps, Theme, useTheme } from "@mui/material";
import { useState } from "react";
import { ChevronSmallRightIcon } from "@/components/common/icons";
import RadioList, { RadioItem } from "@/components/common/list/radioList";
import SlideBottomDialog from "@/components/common/modals/slideBottomDialog";

export type SelectBaseProps = {
  isDisabled?: boolean;
  sx?: SxProps<Theme>;
  selectSubtitle?: React.ReactNode;
};

type SelectProps = SelectBaseProps & {
  title: string;
  items: RadioItem[];
  selectedValue: string;
  onClose: () => void;
  onSubmit: () => void;
};

function Select({
  title,
  items,
  selectedValue,
  isDisabled,
  sx,
  selectSubtitle,
  onClose,
  onSubmit,
}: SelectProps) {
  // Please use newSelect instead of this component,
  // it supports custom inputNode if needed and has a better overall design

  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box sx={sx}>
      <Button
        variant="outlined"
        disabled={isDisabled}
        onClick={() => setIsOpen(true)}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderColor: "gray.light",
          borderWidth: 1.5,
          borderRadius: "12px",
          color: "text.primary",
          fontWeight: "normal",
          fontSize: 16,
          lineHeight: "24",
          width: "100%",
          p: 1.5,
          ":hover": {
            borderWidth: 1.5,
          },
        }}
        disableRipple
      >
        {selectedValue}
        <ChevronSmallRightIcon color={theme.palette.primary.main} />
      </Button>
      <SlideBottomDialog
        open={isOpen}
        title={title}
        submitButtonText="Save"
        onClose={() => {
          setIsOpen(false);
          onClose();
        }}
        onSubmit={() => {
          setIsOpen(false);
          onSubmit();
        }}
      >
        <>
          {selectSubtitle}
          <RadioList items={items} />
        </>
      </SlideBottomDialog>
    </Box>
  );
}

export default Select;
